var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyIndent"},[_c('div',{class:[_vm.emptyName === 'noProductList' ? 'product' : 'hide']}),_c('div',{class:[_vm.emptyName === 'noProductList' ? 'productDiv' : '']},[_c('img',{attrs:{"src":_vm.imgUrl}})]),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }